import type { Routes } from '@angular/router';

export const REVIEW_TEMPLATES_ROUTES: Routes = [
    {
        path: '',
        loadComponent: () =>
            import('#modules/templates/views/review-templates/review-templates.component').then((m) => m.ReviewTemplatesComponent),
    },
];
